import React, { Component } from 'react';
import Select from 'react-select';
import { callApi } from "../../utils/api";
import _ from 'lodash';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore
} from "react-toasts";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import moment from "moment";
import { cloneDeep } from 'lodash';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { Tooltip } from "antd";

declare var $: any;


interface AllProps {
    history: any
}
export class QaManage extends Component<AllProps> {
    state = {
        bank_templates: [],
        bank_id: "",
        fieldNameOptions: [],
        config: {
            id: "",
            bank_template_id: "",
            question: "",
            answer: "",
            is_editable: 1,
            field_name: "",
            questionCheckBox: false,
            questionRadio: "",
            showSubForm: false,
            subItems: []
        },
        qaList: [],
        isEdited: false,
        isSorting: false,
        outreason: "",
        selectVal: false,
        isLoading: false
    };
    refItems: any = [];

    componentDidMount() {
        this.getTemplates();
        this.getFieldNameOptions();
        this.getOutTime();
        this.ouTime();
    }
    getFieldNameOptions = () => {
        callApi("POST", "qa_field_name_get.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ fieldNameOptions: response?.responseJson?.data || [] });
            })
            .catch(err => {
                console.log(err);
            });
    };
    getTemplates = () => {
        callApi("POST", "bank_temp_get.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ bank_templates: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    };
    getQAByBankId = (id) => {
        this.setState({ qaList: [], isLoading: true });
        const obj = {
            bank_template_id: id
        }
        callApi("POST", "question_answer_get.php", obj)
            .then(res => res.data)
            .then(response => {
                let resData = response.responseJson.data;
                if (response.statusCode == 200) {
                    resData = _.sortBy(resData, (o) => {
                        return Number(o.uiIndex);
                    });
                    let counter = 0, obj: any = {};
                    this.setState({ qaList: resData, isLoading: false });
                } else {
                    this.setState({ qaList: [], isLoading: false });
                }
            })
            .catch(err => {
                console.log(err);
            });
    }
    handleTempChange = (data) => {
        const { isEdited, qaList } = this.state;
        if (isEdited && qaList.length > 0) {
            ToastsStore.warning("Please save changes before changing bank template");
        } else {
            if (data.id !== undefined && data.id !== null && data.id !== '') {
                this.setState({ bank_id: data.id });
                this.getQAByBankId(data.id);
            }
        }
    }
    handleChange = (e, i) => {
        const list: any[] = this.state.qaList;
        list[i][e.target.name] = e.target.value;
        this.setState({
            isEdited: true,
            qaList: list
        });
    }
    handleNonEditableToggle = (e, i) => {
        const { checked } = e.target;
        const list: any[] = this.state.qaList;
        list[i].is_editable = checked ? 0 : 1;
        if (!checked) {
            list[i].field_name = "";
        }
        this.setState({
            isEdited: true,
            qaList: list
        });
    }

    questionHandleChange = (e, i) => {
        const list: any[] = this.state.qaList;
        list[i]['question'] = e;
        this.setState({
            isEdited: true,
            qaList: list
        });
    }
    addQa = () => {
        const data = JSON.parse(JSON.stringify(this.state.config));
        const list: any[] = this.state.qaList;
        data.bank_template_id = this.state.bank_id;
        data.uiIndex = list.length
        list.push(data);
        this.setState({ qaList: list });
    }
    removeqa = (i, data) => {
        const list: any[] = this.state.qaList;
        if (data.id !== '') {
            const obj = { id: data.id }
            callApi("POST", "question_answer_delete.php", obj)
                .then(res => res.data)
                .then(response => {
                    list.splice(i, 1);
                    this.setState({ qaList: [] });
                    this.setState({ qaList: list });
                    ToastsStore.success("QA Successfully Deleted");
                    this.getQAByBankId(this.state.bank_id);
                })
                .catch(err => {
                    console.log(err);
                    ToastsStore.error("Error in deleting Q & A, Please try again!");
                });
        } else {
            list.splice(i, 1);
            this.setState({ qaList: [] }, () => {
                this.setState({ qaList: list });
            });
        }
    }
    saveQA = () => {
        const obj = {
            question_answer: this.state.qaList
        };
        callApi("POST", "question_answer_add.php", obj)
            .then(res => res.data)
            .then(response => {
                this.setState({ isEdited: false, qaList: [] }, () => {
                    this.getQAByBankId(this.state.bank_id);
                });
                ToastsStore.success("Successfully Added");
            })
            .catch(err => {
                console.log(err);
                ToastsStore.error("Something went wrong, Please try again!");
            });
    }

    addSort = () => {
        this.setState({ isSorting: true }, () => {
            $(document).ready(function () {
                $("#drag-main")
                    .sortable({
                        items: "div.drag-section",
                        // update: function (e, ui) {
                        //     console.log(e.target,ui)
                        // }
                    });

                // Initialize dragtable if supported and correctly imported
                if ($.fn.dragtable) {
                    $("#drag-main").dragtable({ dragHandle: "#drag-main" });
                }

                // Initialize tablesorter if supported and correctly imported
                if ($.fn.tablesorter) {
                    $("#drag-main").tablesorter();
                }
            });
        });
    };


    reOrderQA = () => {
        const table: any = document.getElementById("drag-main");
        const { qaList } = this.state;
        const updatedQAList: any = [];
        let updatedKeyList: any = [];
        let currentId: Number, currentObject: any;
        if (table.children) {
            for (let i = 0; i < table.children.length; i++) {
                updatedKeyList.push(table.children[i].attributes[1].value)
            }
        }
        let currentObj: any = {};
        updatedKeyList.forEach((element, elementIndex) => {
            currentObj = qaList.filter((val: any) => {
                return val.id === element;
            });
            if (currentObj.length > 0) {
                currentObj = currentObj[0];
                delete currentObj.uiIndex;
                currentObj.uiIndex = elementIndex;
                updatedQAList.push(currentObj);
            }
        });
        this.setState({ qaList: updatedQAList }, () => {
            this.saveQA()
        })
    }

    removeSort = () => {
        this.setState({ isSorting: false }, () => {
            this.reOrderQA()
        })
        $(document).ready(function () {
            $(function () {
                $("#drag-main")
                    .sortable('destroy')
            });
        });
    }
    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "insert_id": insertId
            }

            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    let process_officerId: any = localStorage.getItem("process_office_id");
                    let process_officer_id = JSON.parse(process_officerId);
                    const userid1: any = localStorage.getItem("user1");
                    let user_id = JSON.parse(userid1);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const user: any = localStorage.getItem("user");
                    const getfileId: any = localStorage.getItem("currentfileId");
                    if (process_officer_id == user_id && take_file != "" && take_file == getfileId) {
                        this.fileout(fileid1);
                    } else {
                        localStorage.removeItem('currentfileId');
                    }
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }
    fileout = (fileid1) => {
        let fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser)
        }
        callApi("POST", "time_update.php", req)
            .then(res => res.data)
            .then(response => {
                localStorage.removeItem('currentfileId');
                // localStorage.removeItem("takenfile_id");
            });
    }
    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            // this.setState({})
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };

    radioOnChange = (e, index, item) => {
        const { value } = e.target;
        let baseArray = cloneDeep(this.state.qaList);
        if (item.questionCheckBox == true) {
            baseArray[index] = {
                ...baseArray[index],
                questionRadio: value,
                answer: value
            };
        }

        this.setState({ qaList: baseArray });
    }

    handleCheckboxChange = (e, index, item) => {
        const { name, checked } = e.target;
        let baseArray = cloneDeep(this.state.qaList);
        if (name === "questionCheckBox") {
            let answer;
            if (checked) {
                answer = "No";
            } else {
                answer = "";
            }
            baseArray[index] = {
                ...baseArray[index],
                answer: answer,
                questionCheckBox: checked,
                questionRadio: checked ? "No" : "",
            };
        } else if (name === "showSubForm") {
            baseArray[index].showSubForm = checked;
        }

        this.setState({ qaList: baseArray });
    }

    addSubItem = (qaIndex: number) => {
        this.setState((prev: any) => ({
            qaList: prev.qaList.map((item, i) =>
                i === qaIndex
                    ? {
                        ...item,
                        subItems: [...(item.subItems || []), {
                            id: Date.now().toString(),
                            dropdownValue: "",
                            inputValue: ""
                        }]
                    }
                    : item
            )
        }));
    };

    removeSubItem = (qaIndex: number, subIndex: number) => {
        const updatedList: any = [...this.state.qaList];

        if (!Array.isArray(updatedList[qaIndex].subItems)) return; // prevent error

        updatedList[qaIndex].subItems = updatedList[qaIndex].subItems.filter(
            (_: any, i: number) => i !== subIndex
        );

        this.setState({ qaList: updatedList });
    };

    handleSubItemChange = (qaIndex, subIndex, field, value) => {
        this.setState((prev: any) => ({
            qaList: prev.qaList.map((item, i) =>
                i === qaIndex
                    ? {
                        ...item,
                        subItems: item.subItems?.map((sub, j) =>
                            j === subIndex ? { ...sub, [field]: value } : sub
                        ) || []
                    }
                    : item
            )
        }));
    };

    render() {
        const { bank_templates, bank_id, qaList, isSorting, fieldNameOptions } = this.state;
        return (
            <section className="policymain-container" id="qa-manage" style={{ paddingTop: "60px !important" }}>
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <button
                                    className="btn btn-primary"
                                    style={{ marginBottom: '10px' }}
                                    onClick={() => this.props.history.goBack()}
                                >
                                    Back
                                </button>
                                <div className="page-wrapper">
                                    <div className="card">
                                        {/* Enhanced Header */}
                                        <div className="card-header policy-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 px-4 py-3">
                                            <h5 className="mb-0 text-dark fw-semibold">Q & A Management</h5>
                                            {bank_id !== '' && (
                                                <div className="d-flex gap-2">
                                                    <button className="btn btn-success btn-sm px-4" onClick={this.saveQA}>
                                                        <i className="feather icon-save me-2"></i>
                                                        Save & Submit
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm px-4 ${isSorting ? 'btn-warning' : 'btn-outline-primary'}`}
                                                        onClick={() => isSorting ? this.removeSort() : this.addSort()}
                                                    >
                                                        {isSorting ? (
                                                            <>
                                                                <i className="feather icon-check me-2"></i> Save Order
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="feather icon-shuffle me-2"></i> Reorder
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {/* Action Bar */}
                                        <div className="card-body border-bottom bg-light">
                                            <div className="row g-3 align-items-end">
                                                <div className="col-md-6">
                                                    {bank_id !== '' && (
                                                        <button className="btn btn-primary" onClick={this.addQa}>
                                                            <i className="feather icon-plus me-2"></i>
                                                            Add New Q&A
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="template-select">
                                                        {bank_templates && bank_templates.length > 0 && (
                                                            <Select
                                                                options={bank_templates.map((opt: any) => ({ ...opt, label: opt.name, value: opt.id }))}
                                                                value={bank_templates.find((o: any) => o.value === bank_id)}
                                                                onChange={this.handleTempChange}
                                                                placeholder="Select Template..."
                                                                classNamePrefix="react-select"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-body">
                                            <div className="dt-responsive table-responsive">
                                                <div className="qa-sec drag-menu" id="drag-main">
                                                    {!this.state.isLoading && qaList.map((item: any, index) => (
                                                        <div className="qa drag-section" data-ref-key={item.id} key={index} style={isSorting ? { cursor: "move" } : {}} ref={(ref: any) => this.refItems[item.uiIndex] = index}>
                                                            <div className="row m-0">
                                                                <div className="col-md-1 sno">
                                                                    <span>{index + 1}. </span>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <label>Question</label>
                                                                    <SunEditor defaultValue={item.question}
                                                                        height='100'
                                                                        name="question"
                                                                        setDefaultStyle="font-size: 12px;"
                                                                        disable={isSorting ? true : false}
                                                                        onChange={(e) => this.questionHandleChange(e, index)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                                                                        <label style={{ marginBottom: 0 }}>Answer</label>
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`noneditable-${index}`}
                                                                                checked={item.is_editable === 0}
                                                                                onChange={(e) => this.handleNonEditableToggle(e, index)}
                                                                                disabled={isSorting ? true : false}
                                                                            />
                                                                            <label htmlFor={`noneditable-${index}`} style={{ marginBottom: 0 }}>Non-Editable Field</label>
                                                                        </div>
                                                                        {item.is_editable === 0 && (
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}>
                                                                                <label style={{ marginBottom: 0, whiteSpace: "nowrap" }}>Field Name</label>
                                                                                <select
                                                                                    className="form-control"
                                                                                    name="field_name"
                                                                                    value={item.field_name || ""}
                                                                                    onChange={(e) => this.handleChange(e, index)}
                                                                                    disabled={isSorting ? true : false}
                                                                                >
                                                                                    <option value="">Select Field Name</option>
                                                                                    {(fieldNameOptions || []).map((opt: any) => (
                                                                                        <option key={opt.id} value={opt.value}>{opt.label}</option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ display: "flex", gap: "15px" }}>
                                                                        <div style={{ display: "flex", gap: "5px" }}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`queyes-${index}`}
                                                                                name={`questionRadio-${index}`}
                                                                                value="Yes"
                                                                                className="form-control f-small br-2 wth-90"
                                                                                style={{ fontSize: "2px" }}
                                                                                onChange={e => this.radioOnChange(e, index, item)}
                                                                                checked={item.questionRadio === "Yes"}
                                                                            />
                                                                            <label htmlFor={`queyes-${index}`}>Yes</label>
                                                                        </div>
                                                                        <div style={{ display: "flex", gap: "5px" }}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`queno-${index}`}
                                                                                name={`questionRadio-${index}`}
                                                                                value="No"
                                                                                className="form-control f-small br-2 wth-90"
                                                                                style={{ fontSize: "2px" }}
                                                                                onChange={e => this.radioOnChange(e, index, item)}
                                                                                checked={item.questionRadio === "No"}
                                                                            />
                                                                            <label htmlFor={`queno-${index}`}>No</label>
                                                                        </div>
                                                                    </div>
                                                                    <textarea className="form-control" disabled={isSorting ? true : false} rows={8} name="answer" value={item.answer} onChange={(e) => this.handleChange(e, index)}></textarea>
                                                                </div>

                                                                <div className="col-md-1 display-flex" style={{ alignItems: "center", gap: "20px", display: "grid", margin: "auto", justifyContent: "flex-end" }}>
                                                                    {/* ID Badge */}
                                                                    {item?.id && (
                                                                        <span className="badge bg-secondary text-white px-3 py-2" style={{ fontSize: '14px' }}>
                                                                            {item.id}
                                                                        </span>
                                                                    )}
                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}>
                                                                        <div className="fa-add" onClick={this.addQa}>
                                                                            <i className="fa fa-plus-circle fa-icon" aria-hidden="true" ></i>
                                                                        </div>
                                                                        <div className="fa-delete" onClick={() => this.removeqa(index, item)}>
                                                                            <i className="fa fa-trash fa-icon" aria-hidden="true"></i>
                                                                        </div>
                                                                        <div className="check-box">
                                                                            <input
                                                                                className="form-control"
                                                                                name="questionCheckBox"
                                                                                type="checkbox"
                                                                                style={{ width: "18px", height: "18px" }}
                                                                                checked={item.questionCheckBox === true}
                                                                                onChange={e => this.handleCheckboxChange(e, index, item)}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="switch-box qa-manage-switch">
                                                                        <Tooltip title="Toggle to show/hide additional details form">
                                                                            <label className="switch">
                                                                                <input
                                                                                    name="showSubForm"
                                                                                    type="checkbox"
                                                                                    checked={item.showSubForm === true}
                                                                                    onChange={e => this.handleCheckboxChange(e, index, item)}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </Tooltip>
                                                                    </div>

                                                                </div>
                                                                {/* Accordion - Only show if checkbox is checked */}
                                                                {item?.showSubForm && (
                                                                    <Accordion className="col-md-10 mt-3" style={{ marginLeft: "40px" }}>
                                                                        <Card>
                                                                            <Accordion.Toggle
                                                                                as="div"
                                                                                eventKey="0"
                                                                                style={{ cursor: "pointer" }}
                                                                                className="border rounded bg-light p-3 m-0"
                                                                                onClick={() => {
                                                                                    this.setState((prev: any) => ({
                                                                                        qaList: prev.qaList.map((qa, i) =>
                                                                                            i === index
                                                                                                ? { ...qa, isOpen: !qa.isOpen }  // toggle isOpen
                                                                                                : qa
                                                                                        )
                                                                                    }));
                                                                                }}
                                                                            >
                                                                                <strong>Additional Details</strong> (click to {item.isOpen ? 'hide' : 'show'})
                                                                                <i className={`icon feather icon-${!item.isOpen ? 'plus' : 'minus'}`} style={{ color: 'black', fontSize: '17px', fontWeight: 'bold', float: 'right' }} />
                                                                            </Accordion.Toggle>

                                                                            {item.isOpen && (
                                                                                <Card.Body className="pt-2">
                                                                                    {/* Dynamic Sub-Items List */}
                                                                                    {(item.subItems || []).map((sub: any, subIndex: number) => (
                                                                                        <div key={sub.id || subIndex} className="row mb-3 mt-3 align-items-center">
                                                                                            <div className="col-md-5">
                                                                                                <select
                                                                                                    className="form-control form-control-sm"
                                                                                                    value={sub.dropdownValue || ""}
                                                                                                    onChange={(e) => this.handleSubItemChange(index, subIndex, 'dropdownValue', e.target.value)}
                                                                                                >
                                                                                                    <option value="">Select Type</option>
                                                                                                    <option value="Schedule of Property">Schedule of Property</option>
                                                                                                    <option value="List of Documents (Scrutiny)">List of Documents (Scrutiny)</option>
                                                                                                    <option value="Tracing of History">Tracing of History</option>
                                                                                                    <option value="There Such Paragraph">There Such Paragraph</option>
                                                                                                    <option value="Tracing Possession">Tracing Possession</option>
                                                                                                    <option value="Tracing of Sale Agreement">Tracing of Sale Agreement</option>
                                                                                                    <option value="Tracing Encumbrance Certificate">Tracing Encumbrance Certificate</option>
                                                                                                    <option value="In finally Paragraph">In finally Paragraph</option>
                                                                                                    <option value="List of Documents (To Be Collected)">List of Documents (To Be Collected)</option>
                                                                                                    <option value="Post Disbursement Documents">Post Disbursement Documents</option>
                                                                                                    <option value="Pre Disbursement Documents">Pre Disbursement Documents</option>
                                                                                                    <option value="Remarks">Remarks</option>
                                                                                                </select>
                                                                                            </div>

                                                                                            <div className="col-md-5">
                                                                                                <textarea
                                                                                                    className="form-control form-control-sm"
                                                                                                    style={{ minHeight: "70px", resize: "vertical", whiteSpace: "pre-wrap" }}
                                                                                                    placeholder="Enter details..."
                                                                                                    value={sub.inputValue || ""}
                                                                                                    onChange={(e) => this.handleSubItemChange(index, subIndex, 'inputValue', e.target.value)}
                                                                                                />
                                                                                            </div>

                                                                                            <div className="col-md-2">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-danger rounded-circle"
                                                                                                    style={{ width: '32px', height: '32px', padding: 6 }}
                                                                                                    onClick={() => this.removeSubItem(index, subIndex)}
                                                                                                >
                                                                                                    <i className="feather icon-minus"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}

                                                                                    {/* Add New Detail Button */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-success btn-sm"
                                                                                        onClick={() => this.addSubItem(index)}
                                                                                    >
                                                                                        <i className="feather icon-plus me-2"></i> Add Detail
                                                                                    </button>
                                                                                </Card.Body>
                                                                            )}
                                                                        </Card>
                                                                    </Accordion>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                >{this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                                {/* <div className="col-md-5"> */}
                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>
                                {/* </div> */}

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}
                                    disabled={this.state.isLoading}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"

                                    onClick={() => this.previousPop()}
                                    // onClick={this.disableModalHandler}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default QaManage
